import { MisReservasPage } from './../mis-reservas/mis-reservas.page';
import { Component, OnInit } from '@angular/core';
import { ConsultaService } from 'src/app/services/consulta.service';
import { Router } from '@angular/router';
import { AlertController, IonDatetime } from '@ionic/angular';
import { Reservas } from 'src/app/models/reservas';

@Component({
  selector: 'app-acceso',
  templateUrl: './acceso.page.html',
  styleUrls: ['./acceso.page.scss'],
})
export class AccesoPage implements OnInit {

  public codigo : string;
  public codigoActivo: boolean;
  
  constructor(
    public _consulta : ConsultaService,
    private _router : Router,
    private alertController : AlertController

  ) {
    this.codigoActivo = true;
   }

  ngOnInit() {
    this.getResevas();
  }

  async alertErrorSeleccionarTarjetasLazo() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'No tienes Tarjetas Lazo registradas.',
      buttons: ['OK']
    });
    await alert.present();
  }

  volver(){
    this._router.navigate(['/principal']);
  }

  elegirCodigo(){
    if(this.codigoActivo){
    this._router.navigate(['/elegir-codigo']);    
    }
  }

  getResevas(){
    let x = '{"clave" : "RESERVAS", "id" : "' + this._consulta.usuario.Id + '" }';
    this._consulta.consultoMisReservas(x).subscribe(
      result => {
        this._consulta.misReservas = result.value;
        this.comprobarReservaCodigo();
      },
      error => {
      }
    )
  }

  comprobarReservaCodigo(){

  }
  nada(){
    
  }

}
